export const CREATE_NEW_COLLECTION_KEY = "create-new-collection";
export const BATCH_SIZE = 5;
export const BATCH_API_AUTO_THRESHOLD_CALLS = 100_000;
